export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/hotel.bbfedeb6-73ad95.png";